export default RAILS_ASSET_URL("/poppins-v15-latin-regular.woff2")
